import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

import {AuthService} from "../../login/services/auth.service";
import {AssessmentService } from "../../shared/services/assessment.service";
import {AssessmentGraderService } from "../../shared/services/assessment-grader.service";
import { Assessment } from "../../shared/models/assessment";
import { AssessmentResult } from "../../shared/models/assessment-result";
import { ManagedClient } from "../../shared/models/managed-client";
import { AssignedAssessment } from 'app/shared/models/AssignedAssessment';
import { AssignedLibraryAsset } from 'app/shared/models/AssignedLibraryAsset';
import { AssetService } from 'app/library-assets/services/asset.service';
import { LibraryAsset } from 'app/library-assets/models/library-asset';
import { LibraryAssetResult } from 'app/library-assets/models/library-asset-result';
import { AssignmentItem } from 'app/shared/models/AssignmentItem';

@Component({
  selector: 'app-take-assignment',
  templateUrl: './take-assignment.component.html',
  styleUrls: ['./take-assignment.component.css']
})
export class TakeAssignmentComponent implements OnInit {

  private _assignment:AssignmentItem;
  private _assessment:Assessment;
  private _asset:LibraryAsset;
  private _loading:boolean;
	private _saving:boolean;
  private _client:ManagedClient;

  constructor(private AssessmentService:AssessmentService, 
    private router:Router,
    private authService:AuthService,
    private route: ActivatedRoute,
    private assessmentGrader: AssessmentGraderService,
    private assetService:AssetService,
    private alertService:AlertService
  ) { }

  public get hasAssignment() {
    return this._assignment && this._assignment.Name;
  }

  public get assignmentName() {
    if (this._assignment) {
      return this._assignment.Name;
    }
    return "";
  }

  ngOnInit() {

    this.authService.getCurrentClient().then((client) => {
			this._client = client;

				// not sure I like this nested, but it does handle duplicate requests for the uid.
			this.route.params.subscribe((params) => {
        this.loading = true;
        let id = +params['id'];
        if (isNaN(id)) {
          this.alertService.error("Assessment id was not a valid number.  Cannot load");
          return;
        }
        this._assignment = client.findAssignmentItem(id);
        console.log("Loading assignment ", this._assignment);

        if (this._assignment.Type == 'Assessment') {
          let assignedAssessment = this._assignment as AssignedAssessment;
          this.AssessmentService.clientId = client.id;

          this.AssessmentService.getAssessmentForAssignment(assignedAssessment).then((assessment) => {
              this.loading = false;
              this._assessment = assessment;
              
          })
          .catch((response) => {
              this.loading = false;
              this.alertService.error("Failed to load assessment.  Please check your network connection or contact customer support");	
              console.error(response); 
          });
        } else {
          let libraryAsset= this._assignment as AssignedLibraryAsset;
          this.assetService.getAsset(libraryAsset.AssetId).then((asset:LibraryAsset) => {
            this._loading = false;
            this._asset = asset;
          })
          .catch((response) => {
              this.loading = false;
              this.alertService.error("Failed to load assignment.  Please check your network connection or contact customer support");	
              console.error(response); 
          })
        }



       
			});
		}); 
  }

  submitAsset(assetResult:LibraryAssetResult) {

    // create the exercise results

    // grab all the answers
    let savingMsg = this.alertService.info("Saving your assignment....", 600000)
    assetResult.assignmentItemId = this._assignment.Id;
    this.assetService.saveAssetResult(assetResult).then(result => {
      this.alertService.success("Saved answers for " + result.asset.title);
      this.alertService.clearAlert(savingMsg);
      // TODO: stephen not sure I like this as the assignment and the client have to maintain knowledge of each other
      // of course we need it as we need to grab the next assignment from the client..
      this._assignment.ResultId = result.id;
      this._client.markAssignmentCompleted(this._assignment);
      this.navigateToNextDestinationForAssignmentItem(this._assignment);
    })
    .catch(error => {
      this.alertService.clearAlert(savingMsg);
        console.error("Failed to save json result", error);
        this.saving = false;
        this.alertService.error("There was an error in saving your assignment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
    })
  }

  submitAssessment(assessment:Assessment) {
		this.saving = false;
		let result = this.createAssessmentResultFromAssessment(assessment);
	
    this.saving = true;
    let savingMsg = this.alertService.info("Computing your test results and saving your scores....", 600000)
    this.AssessmentService.saveAssessmentResult(result)
			.then((result:AssessmentResult) => {
        this.alertService.success("Saved results for " + this.assignmentName);
        this.alertService.clearAlert(savingMsg);
        setTimeout(() => {
          let assignment = this._assignment as AssignedAssessment;
          assignment.ResultId = result.id; // this is all saved server side, but we'll put it here
          // TODO: stephen not sure I like this as the assignment and the client have to maintain knowledge of each other
          // of course we need it as we need to grab the next assignment from the client..
          this._client.markAssignmentCompleted(this._assignment);
          this.navigateToNextDestinationForAssignmentItem(this._assignment);
        }, 1000); // have a slight delay to show we are doing something
      })
      .catch((error) => {
        this.alertService.clearAlert(savingMsg);
        console.error("Failed to save json result", error);
        this.saving = false;
        this.alertService.error("There was an error in saving your assessment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
      });
  }
  
  private navigateToNextDestinationForAssignmentItem(item:AssignmentItem) {
    if (!this._client.hasFinishedAllAssignments()) {
      let itemAssignment = this._client.getNextAssignmentItemToComplete();
      this.saving = false;
      this.router.navigate(["../", itemAssignment.Id], {relativeTo: this.route});
    }
    else {
      this.alertService.success("Congratulations!  You have finished your assigned assessments");
      this.router.navigate(["../../"], {relativeTo: this.route});
    }
  }

  private createAssessmentResultFromAssessment(assessment:Assessment) {
    var result = this.assessmentGrader.grade(assessment);
		result.assignmentItemId = this._assignment.Id;
    return result;
  }

  public shouldDisplayAssessment() {
    return this._assignment && this._assignment.Type == 'Assessment';
  }

  public shouldDisplayExercise() {
    return this._assignment && this._assignment.Type == 'LibraryAsset' && this._asset && this._asset.type == 'assignment';
  }

  public shouldDisplayArticle() {
    return this._assignment && this._assignment.Type == 'LibraryAsset' && this._asset && this._asset.type == 'article';
  }

  public get loading() : boolean {
		return this._loading;
	}
	
	
	public set loading(v : boolean) {
		this._loading = v;
	}
	
	public get saving() : boolean {
		return this._saving;
	}
	
	
	public set saving(v : boolean) {
		this._saving = v;
	}
	
   public get assessment() : Assessment {
    return this._assessment;
  }

  public get asset() : LibraryAsset {
    return this._asset;
  }

}



// WEBPACK FOOTER //
// ./src/app/assessments/take-assignment/take-assignment.component.ts